/**
 * V2QsEqVas 컴포넌트 Props 인터페이스
 *
 * EQ-VAS (EuroQol Visual Analogue Scale) - 표준 PROM 문제 유형
 * 세로 눈금자(0~100)에서 환자가 건강 상태를 선택하는 컴포넌트
 */

export interface V2QsEqVasProps {
  /**
   * 현재 선택된 값 (0~100)
   */
  value?: number;

  /**
   * 값 변경 시 콜백
   */
  onChange?: (value: number) => void;

  /**
   * 눈금자 상단 라벨
   * @default 'Best imaginable health state'
   */
  topLabel?: string;

  /**
   * 눈금자 하단 라벨
   * @default 'Worst imaginable health state'
   */
  bottomLabel?: string;

  /**
   * 값 입력 박스 라벨
   * @default 'Your health today ='
   */
  valueBoxLabel?: string;

  /**
   * 왼쪽 영역 제목 (질문 라벨)
   */
  title?: React.ReactNode;

  /**
   * 왼쪽 영역 설명 텍스트 (질문 설명/안내문)
   */
  leftText?: string;

  /**
   * 눈금자 높이 (px)
   * @default 500
   */
  scaleHeight?: number;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;

  /**
   * 읽기 전용 여부
   */
  readOnly?: boolean;

  /**
   * 에러 상태
   */
  hasError?: boolean;

  /**
   * 에러 메시지
   */
  errorMessage?: string;

  /**
   * 추가 CSS 클래스
   */
  className?: string;
}

export const defaultV2QsEqVasProps: Partial<V2QsEqVasProps> = {
  topLabel: '',
  bottomLabel: '',
  valueBoxLabel: '',
  scaleHeight: 500,
  disabled: false,
  readOnly: false,
  hasError: false,
};
